import {APP_BACKEND_API_ENDPOINT, APP_IMPRINT_URL, APP_LOCALE, APP_LOGO_URL, APP_PRIVACY_URL, APP_PUBLIC_BOOKING_EMAIL} from "../env";

export default {
    language: APP_LOCALE,
    apiUrl: APP_BACKEND_API_ENDPOINT,
    appLogo: APP_LOGO_URL,
    publicBookingEmail: APP_PUBLIC_BOOKING_EMAIL,
    imprintUrl: APP_IMPRINT_URL,
    privacyUrl: APP_PRIVACY_URL,
};
